import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Table } from 'components/common/Elements/Elements';
import SubCellBody from '../SubCellBody/SubCellBody';

import { subTableConf } from '../../helpers/configurates';

import classes from './SubTable.module.scss';

const SubTable = ({ row, mouseLeave, mouseEnter, dataSub }) => {
  const calcHeigth = () => {
    const sourcesHeight = dataSub.sources.length * 32;
    const destinationsHeight =
      dataSub.destinations.filter(item => item.endpointType === 'address')
        .length * 32;
    const serviceHeight =
      dataSub.destinations.filter(item => item.endpointType === 'service')
        .length * 32;

    const resultHeigth =
      sourcesHeight > destinationsHeight && sourcesHeight > serviceHeight
        ? sourcesHeight
        : destinationsHeight > serviceHeight
        ? destinationsHeight
        : serviceHeight;
    return resultHeigth === 32 || resultHeigth === 0
      ? 32 * 2 + 2
      : resultHeigth;
  };

  return (
    <Table.Row className={classes.subTable_wrap}>
      <Table.Cell className={classes.resetCell}>
        <div
          style={{ height: `calc(52px + ${calcHeigth()}px)` }}
          className={classes.fixCell}
        >
          <div className={classes.headerDecor} />
          <Table className={classes.subTable}>
            <Table.Header>
              <Table.Row>
                {subTableConf.map(({ field, title }, idx) => (
                  <Table.HeaderCell
                    key={field}
                    className={classes.subTable_header}
                    onMouseEnter={mouseEnter}
                    onMouseLeave={mouseLeave}
                    r={`r${idx + 10}`}
                    title={title}
                  />
                ))}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row className={classes.subTable_row}>
                <Table.Cell
                  className={cn(
                    classes.subTable_cell,
                    row === 'r10' && classes.hov
                  )}
                  classNameContent={classes.id}
                  onMouseEnter={mouseEnter}
                >
                  <SubCellBody data={dataSub.sources} />
                </Table.Cell>
                <Table.Cell
                  className={cn(
                    classes.subTable_cell,
                    row === 'r11' && classes.hov
                  )}
                  classNameContent={classes.id}
                  onMouseEnter={mouseEnter}
                >
                  <SubCellBody
                    data={dataSub.destinations.filter(
                      item => item.endpointType === 'address'
                    )}
                  />
                </Table.Cell>
                <Table.Cell
                  className={cn(
                    classes.subTable_cell,
                    row === 'r12' && classes.hov
                  )}
                  classNameContent={classes.id}
                  onMouseEnter={mouseEnter}
                >
                  <SubCellBody
                    data={dataSub.destinations.filter(
                      item => item.endpointType === 'service'
                    )}
                  />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};

SubTable.propTypes = {
  row: PropTypes.string,
  mouseLeave: PropTypes.func,
  mouseEnter: PropTypes.func,
  dataSub: PropTypes.object.isRequired
};

export default SubTable;
